import { inject, Injectable } from '@angular/core'
import { CanActivate, CanActivateChild, GuardResult, MaybeAsync, Router } from '@angular/router'
import { ProcessingUserService } from '@modules/user-module/services/processing-user.service'

@Injectable({
	providedIn: 'root',
})
export class NotProcessedGuard implements CanActivate, CanActivateChild {
	private readonly _processingUserService: ProcessingUserService =
		inject<ProcessingUserService>(ProcessingUserService)
	private readonly _router: Router = inject<Router>(Router)

	private _checkProcessingUser(): boolean {
		if (!this._processingUserService.isSuccessProcessedUser) return true
		this._router.navigate(['/cabinet'])
		return false
	}

	canActivate(): MaybeAsync<GuardResult> {
		return this._checkProcessingUser()
	}

	canActivateChild(): MaybeAsync<GuardResult> {
		return this._checkProcessingUser()
	}
}
